export const ENV = {
  mode: 'Development',
  version: 't',
  appversion: '2.0.0',
  apiUrl: 'https://testapp.toptotaal.nl/api_v2/',
}



// WEBPACK FOOTER //
// ./src/environments/environment.dev.ts